import { Buffer } from 'buffer/';
export const codeToBase64 = (dhTransformations) => {
    if (!dhTransformations || !dhTransformations.length) {
        return '';
    }
    const objectString = JSON.stringify(dhTransformations);
    const coded = Buffer.from(objectString).toString('base64');
    return `?t=${coded}`;
};
export const removePrefix = (source, prefixRegex) => {
    return source.replace(prefixRegex, '');
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function deepMerge(target, ...sources) {
    if (!sources.length) {
        return target;
    }
    const source = sources.shift();
    if (isMergeable(target) && isMergeable(source)) {
        for (const key in source) {
            if (isMergeable(source[key])) {
                if (!(key in target))
                    Object.assign(target, { [key]: {} });
                deepMerge(target[key], source[key]);
            }
            else {
                Object.assign(target, { [key]: source[key] });
            }
        }
    }
    else if (Array.isArray(target) && Array.isArray(source)) {
        target.push(...source);
    }
    else {
        target = source;
    }
    return deepMerge(target, ...sources);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isMergeable(obj) {
    return obj && typeof obj === 'object' && !Array.isArray(obj) && !(obj instanceof Date);
}
//# sourceMappingURL=utils.js.map